import { useState } from 'react';
import { faSquareArrowDownLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonWithTooltip,
  insertDirective$,
  usePublisher,
} from '@mdxeditor/editor';
import { useTranslation } from 'react-i18next';

import type { IIframeMdxDirectiveDialogFormValues } from './IframeMdxDirectiveDialogForm';
import { IFRAME_MDX_DIRECTIVE_NAME } from './iframeMdxDirectiveConstants';
import { IframeMdxDirectiveDialogForm } from './IframeMdxDirectiveDialogForm';

export type IIframeMdxDirectiveToolbarButtonProps = Record<string, never>;

export type IIframeMdxDirectiveAttributes = {
  url: string;
};

export const IframeMdxDirectiveToolbarButton: React.FC<
  IIframeMdxDirectiveToolbarButtonProps
> = () => {
  const insertDirective = usePublisher(insertDirective$);
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = (values: IIframeMdxDirectiveDialogFormValues): void => {
    setOpened(false);

    const attributes: IIframeMdxDirectiveAttributes = {
      url: values.url ?? '',
    };

    insertDirective({
      name: IFRAME_MDX_DIRECTIVE_NAME,
      type: 'leafDirective',
      attributes,
    });
  };

  return (
    <>
      <IframeMdxDirectiveDialogForm
        opened={opened}
        onClose={() => setOpened(false)}
        onSubmit={handleSubmit}
      />

      <ButtonWithTooltip
        title={t('IframeMdxDirectiveToolbarButton.tooltip')}
        onClick={() => setOpened(true)}
      >
        <FontAwesomeIcon
          icon={faSquareArrowDownLeft}
          fontSize={18}
          style={{ padding: 3 }}
        />
      </ButtonWithTooltip>
    </>
  );
};
